import { render, staticRenderFns } from "./Vessels.vue?vue&type=template&id=342f4fe6&scoped=true"
import script from "./Vessels.vue?vue&type=script&lang=js"
export * from "./Vessels.vue?vue&type=script&lang=js"
import style0 from "./Vessels.vue?vue&type=style&index=0&id=342f4fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342f4fe6",
  null
  
)

export default component.exports